import { IV2GetMessages } from '../../repositories/cian-chat-bot/entities/get_messages_response/V2GetMessages';
import { TGetMessagesResponse, fetchGetMessages } from '../../repositories/cian-chat-bot/v2/get-messages';
import { IChatbotMessageSchema } from '../../types/chatbot';
import { TContext } from '../../types/context';
import { EExceptionDomain } from '../../types/exceptionDomains';
import { TMessageSchema } from '../../types/messages';
import { ETelemetryEvents } from '../../types/telemetry';
import { getGenericLikeError } from '../../utils/logging/getGenericLikeError';
import { getResponseError } from '../../utils/logging/getResponseError';
import { mapChatbotMessageToChatMessage } from '../../utils/mapChatbotMessageToChatMessage';

export type IGetMessagesResponse = IV2GetMessages;

const DEFAULT_EXCEPTION_MESSAGE = 'Не удалось получить сообщение от чатбота';

export async function fetchChatbotMessages(
  { httpApi, logger, telemetry }: TContext,
  rowVersion: number,
): Promise<(Omit<IGetMessagesResponse, 'messages'> & { messages: TMessageSchema[] }) | null> {
  const parameters = {
    rowVersion,
    excludeDeleted: true,
  };

  try {
    const { statusCode, response }: TGetMessagesResponse = await fetchGetMessages({
      httpApi,
      parameters,
    });

    if (statusCode !== 200) {
      throw getResponseError({
        domain: EExceptionDomain.Chatbot,
        defaultMessage: DEFAULT_EXCEPTION_MESSAGE,
        response,
        statusCode,
      });
    }

    return {
      ...response,
      messages: response.messages.map((message: IChatbotMessageSchema, index: number) =>
        mapChatbotMessageToChatMessage(message, index, response.unreadMessagesCount),
      ),
    };
  } catch (error) {
    telemetry.increment(ETelemetryEvents.ChatbotMessagesFail);

    const errorToLog = getGenericLikeError({
      error,
      domain: EExceptionDomain.Chatbot,
      message: DEFAULT_EXCEPTION_MESSAGE,
    });

    logger.error(errorToLog, {
      microserviceName: 'cian-chat-bot',
      pathApi: '/v2/get-messages/',
      parameters,
    });

    return null;
  }
}
